import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { HttpClient,HttpHeaders  } from '@angular/common/http';
import { ToastrManager } from 'ng6-toastr-notifications';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
 
  rememberme:boolean;
  logindata:any;
  username:any;
  password:any;
  Alertmessage:any;
  baseurl:any;
  login_error:any;
  showalert:boolean;
  
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    observe: 'response' as 'response',
    
  };
  loader:boolean = false;
  public loadersub = new BehaviorSubject<boolean>(this.loader);

  constructor(private router: Router,private http:HttpClient,public toastr:ToastrManager) {
     
     }

    //  ----live---------
     url      = "https://aimchassis.com/cams/";
     imageurl = "https://aimchassis.com/";
     emailurl = "https://www.aimchassis.com/objs/";

  

     //  --------dev------------
 
    // url      = "https://camsdev.flexivan.com/cams/";
    // imageurl = "https://camsdev.flexivan.com/";
    // emailurl = "https://camsdev.flexivan.com/objs/";


    getbaseurl(){
      return this.url;
    }
    
    selectdata(urlmethod,dataparam)
    {
      dataparam.x_access_token = window.sessionStorage.getItem('jwttoken');
        if(urlmethod == 'loginchecking')
        {
          return this.http.post(this.url+urlmethod,dataparam,this.httpOptions);
        }
        else
        {
          return this.http.post(this.url+urlmethod,dataparam);
        }
    }

    selectgetdata(urlmethod)
    {
      return this.http.get(this.url+urlmethod);
    }

    emailsending(urlmethod,dataparam)
    {
      return this.http.get(this.emailurl+urlmethod,dataparam);
    }

   

    sendemailurlresp(urlmethod,parameter,reponse)
    {
      return this.http.get(this.emailurl+urlmethod+parameter,{responseType: reponse});
    }

    IUDdata(urlmethod,dataparam,reponse)
    {
      dataparam.x_access_token = window.sessionStorage.getItem('jwttoken');
      return this.http.post(this.url+urlmethod ,dataparam,{responseType: reponse});
    }
    showCloseButton:true


    showToast_closeable(position:any, message:string,duration:number,showclose:boolean,toasttype:any) {
          if(toasttype=='S')
          {
                this.toastr.successToastr(message, '', {
                  position: position,
                  toastTimeout:duration,
                  showCloseButton:showclose
                  
                });
          }
          else  if(toasttype=='E')
          {
            this.toastr.errorToastr(message, '', {
              position: position,
              toastTimeout:duration,
              showCloseButton:showclose
            });
          }
     
      }

  showToasterror(position:any, message:string,duration:number) {
      this.toastr.errorToastr(message, '', {
          position: position,
          toastTimeout:duration
      });
  }
  showSuccess(position:any, message:string,duration:number)
  {
      this.toastr.successToastr(message, '', {
        position: position,
        toastTimeout:duration
      });
  }



  login(first_name: string, password_txt: string) 
  {

          let link = this.getbaseurl()+"loginchecking" ;
            console.log(link);
            
          let data = {
               first_name:first_name,
               password_txt:password_txt,
          };
          
      
          
          const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            observe: 'response' as 'response',
            
          };
         
         this.http.post<any>(link,data, httpOptions).subscribe((resp:any) => 
         {
            var header= resp.headers.get('x-access-token');
            // this.localstorage.set('jwttoken',header );
            window.sessionStorage.setItem('jwttoken',header )
          
                if(resp.body.length > 0)
                {
                  
                      if(resp.body[0].user_status=='A')
                      {
                        if(resp.body[0].user_role=='PC')
                        {
                            window.sessionStorage.setItem('userdata',JSON.stringify(resp.body[0]));
                            window.sessionStorage.setItem('userid',resp.body[0].user_id);
                            window.sessionStorage.setItem('username',resp.body[0].first_name );
                            this.router.navigate(['/home']);
                        }
                        else
                        {
                            this.showToasterror( 'top-center','You are Not Pool User',4000);
                        }

                      } 
                      else if(resp.body[0].user_status=='V')
                      {
                        this.showToasterror( 'top-center','Your Account Is Not Activate',4000);
                      }
                      else if(resp.body[0].user_status=='P')
                      {
                        this.showToasterror( 'top-center','Your Account Is Not Verified',4000);
                      }
                      else if(resp.body[0].user_status=='S')
                      {
                        this.showToasterror( 'top-center','Your Account Is Suspended',4000);
                      }

                }
                else 
                {
                    this.login_error = "Invalid Email Or Password" ;
                    this.showToasterror( 'top-center','Invalid Email Or Password',4000);
                }

        });
    
  }

  logout() {
    if(window.sessionStorage.getItem('userid') != null)
    {
      this.router.navigate(['/fccp/fccplogin']);
      // if(this.getstoragedtl().user_role == 'PC')
      // {
      //   this.router.navigate(['/fccp/fccplogin']);
      // }
      // else{
      //   this.router.navigate(['/auth/login']);
      // }
      window.sessionStorage.clear();
      window.sessionStorage.setItem('jwttoken','' )
    }
    
   
  //  window.sessionStorage.removeItem('userid');
    
  }

getstoragedtl(){
  return JSON.parse( window.sessionStorage.getItem('userdata'));
}
resetstoragevalues(columntxt,colval)
{
  var locdata = this.getstoragedtl();
  locdata[columntxt] = colval;
  window.sessionStorage.setItem('userdata',JSON.stringify(locdata));
}
localstorageupdate(key,value)
{
  localStorage.setItem(key,value);
}
getlocalstoragevalues(key)
{
  return localStorage.getItem(key);
}

sendemailurllink(urlmethod,parameter,reponse)
{
  return this.http.get(this.emailurl+urlmethod+parameter,{responseType: reponse});
}

showloader(status)
{
  this.loader = status;
  setTimeout(() => {
    this.loadersub.next(this.loader);
  });
}

generatePIN(digits){
  var i = 0; //counter
  var pin = ""; //our default pin is blank.
  while(i < digits){
      //generate a random number between 0 and 9.
      pin += Math.floor(Math.random() * (9 - 0) + 0);
      i++;
  }
  return pin;
}

getaccesiblestring(permtxt)
{
  if(permtxt.length > 0)
  {
    permtxt = permtxt.split('|');
      return {
        btnsave:permtxt[0],
        btnupdate:permtxt[1],
        btndelete:permtxt[2],
        btnview:permtxt[3],
        btnprint:permtxt[4],
        btnexport:permtxt[5]
      };
  }
}
getemailobjectstring(dataobj)
{
  var datatxt = '';
  for (var key in dataobj) {
    datatxt += key+"="+dataobj[key]+"&";
  }
  return datatxt.slice(0,-1);

}
}

